var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ActivateList',{attrs:{"_type":_vm.$data._corporateType.testCenter.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }